import React, { useRef, useState, useEffect } from "react";
import { useFormikContext } from "formik";

const PinInput = ({ name = "password", label = "PIN" }) => {
    const { setFieldValue, values, errors, touched } = useFormikContext();
    const [pin, setPin] = useState(["", "", "", ""]);
    const inputs = [useRef(), useRef(), useRef(), useRef()];

    useEffect(() => {
        if(values[name] === ""){
            setPin(["", "", "", ""]);
        }
    }, [values[name], name])

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (!/^\d?$/.test(value)) return;

        const newPin = [...pin];
        newPin[index] = value;
        setPin(newPin);
        setFieldValue(name, newPin.join(""));

        if (value && index < 3) {
            inputs[index + 1].current.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !pin[index] && index > 0) {
            const newPin = [...pin];
            newPin[index - 1] = "";
            setPin(newPin);
            inputs[index - 1].current.focus();
        }
    };

    return (
        <div className="w-full font-semibold">
            <label className="block mb-1 text-gray-600">{label}</label>
            <div className="flex justify-space space-x-2">
                {pin.map((digit, index) => (
                    <input
                        key={index}
                        ref={inputs[index]}
                        type="password"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        autoComplete="off"
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        className="w-12 h-12 md:w-10 md:h-10 px-2.5 py-2 text-center text-2xl text-gray-600 bg-white border border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-0 focus:border-gray-600 peer"
                    />

                ))}
            </div>
            {touched[name] && errors[name] && (
                <p className="text-red-500 text-xs italic mt-1">{errors[name]}</p>
            )}
        </div>
    );
};

export default PinInput;